<template>
	<nut-navbar
		class="navbar"
		title="设备运行检测"
		fixed
		:placeholder="false"
		leftShow
		@on-click-back="goBack"
	>
		<template #right>
			<a
				class="help-link"
				href="http://about.duodong.site/static/deviceFaultSolutions.html"
				target="_blank"
				>帮助</a
			>
		</template>
	</nut-navbar>
	<div class="container">
		<div class="result" v-html="result"></div>
	</div>
</template>

<script>
import { onMounted, ref } from 'vue';
import useNavigate from '@/hooks/useNavigate';
import { settingApi } from '@/apis';

export default {
	name: 'DeviceExamine',
	components: {},
	setup() {
		const { goBack } = useNavigate();
		const result = ref('');
		const getExamineResult = async () => {
			const res = await settingApi.examine_device();
			result.value = res.result;
		};

		onMounted(() => {
			getExamineResult();
		});
		return {
			result,
			goBack,
		};
	},
};
</script>

<style lang="scss" scoped>
.container {
	margin-top: $navbar-height;
	overflow: hidden;
	background: $bg_color;
	min-height: calc(100vh - $navbar-height);
	.result {
		padding: 10px;
	}
}

.help-link {
	color: #fff;
}
</style>
